// assets
import {
  IconStack,
  IconUsers,
  IconServer,
  IconWind,
  IconPlug,
  IconShoppingCart,
  IconSend,
  IconChartBar,
  IconScale,
  IconAlertTriangle
} from '@tabler/icons';

// constant
const icons = {
  IconStack,
  IconUsers,
  IconServer,
  IconWind,
  IconPlug,
  IconShoppingCart,
  IconSend,
  IconChartBar,
  IconScale,
  IconAlertTriangle
};

// ==============================|| MENU ITEMS ||============================== //

const pages = {
  id: 'pages',
  type: 'group',
  children: [
    {
      id: 'infrastructure',
      title: 'Infrastructure',
      type: 'collapse',
      icon: icons.IconStack,
      children: [
        {
          // customers — parks are grouped and filtered by tenant
          id: 'tenants',
          title: 'Tenants',
          type: 'item',
          url: '/tenants',
          icon: icons.IconUsers,
          breadcrumbs: false
        },
        {
          // OptimalAsset services; one instance can serve several tenants
          id: 'instances',
          title: 'Instances',
          type: 'item',
          url: '/instances',
          icon: icons.IconServer,
          breadcrumbs: false
        },
        {
          // a park belongs to one tenant and lives on one instance
          id: 'parks',
          title: 'Parks',
          type: 'item',
          url: '/parks',
          icon: icons.IconWind,
          breadcrumbs: false
        },
        {
          // trade clients; a park may or may not be linked to one
          id: 'clients',
          title: 'Clients',
          type: 'item',
          url: '/clients',
          icon: icons.IconPlug,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'orders',
      title: 'Orders',
      type: 'collapse',
      icon: icons.IconShoppingCart,
      children: [
        {
          id: 'sent_orders',
          title: 'Sent Orders',
          type: 'item',
          url: '/orders/sent',
          icon: icons.IconSend,
          breadcrumbs: false
        },
        {
          // traded power per contract (exchange + delivery start + duration)
          id: 'traded_volumes',
          title: 'Traded Volumes',
          type: 'item',
          url: '/orders/traded-volumes',
          icon: icons.IconChartBar,
          breadcrumbs: false
        },
        {
          // volumes sent but still resting in the order book
          id: 'open_positions',
          title: 'Open Positions',
          type: 'item',
          url: '/orders/open-positions',
          icon: icons.IconScale,
          breadcrumbs: false
        },
        {
          // why orders were rejected, adjusted or flagged
          id: 'audit_events',
          title: 'Audit Events',
          type: 'item',
          url: '/orders/audit-events',
          icon: icons.IconAlertTriangle,
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default pages;
